<template>
<a :href="url" target="_blank" class="com-article-title" :data-talk="type == 2" @click.stop.prevent="routeArticle">
  <i class="iconfont" v-if="type == 2">&#xe63a;</i>
  {{title | formatContent}}
</a>
</template>

<script>
import VueTypes from 'vue-types'

/**
 * 文章/专题标题
 * @module component/ArticleTitle
 * @example <ArticleTitle :uuid="articleID" :title="articleTitle" :type="type" />
 */
export default {
  name: 'article-title',
  /**
   * 传入数据
   * @property {String|Number}  uuid     文章/专题标题的别名或者 ID
   * @property {String}         title    文章/专题标题
   * @property {Number}        [type=0]  标题类型[0:文章,1:专题,2:话题]
   */
  props: {
    uuid: VueTypes.oneOfType([Number, String]).isRequired,
    title: VueTypes.string.isRequired,
    type: VueTypes.oneOfType([Number, String]).def(0),
    source: VueTypes.string
  },
  /**
   * 计算属性
   * @member
   * @prop {Url} url 根据 type 设置跳转的链接[0:文章,1:专题]
   */
  computed: {
    url () {
      let type = 'article'

      switch (this.type | 0) {
        case 0:
          type = 'article'
          break
        case 1:
          type = 'theme'
          break
        case 2:
          type = 'talk'
          break
        default:
          break
      }

      return this.source ? `/${type}/${this.uuid}?utm_source=${this.source}&utm_medium=article` : `/${type}/${this.uuid}`
    }
  },
  methods: {
    /**
     * 跳转到文章/专题详情页
     * @func
     */
    routeArticle () {
      window.open(this.url)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/common';

.com-article-title {
  @extend %animateFontBlack;
  cursor: pointer;
}
[data-talk] {
  display: inline-block;
  position: relative;
  text-indent: 23px;

  & .iconfont {
    position: absolute; left: 1px; top: 0;
    text-indent: 0;
    font-size: 17px;
    color: $blue;
  }
}
</style>

